export class PressureScaleBoundaries {

  constructor(
    public minPressure: number = Number.MAX_SAFE_INTEGER,
    public maxPressure: number = Number.MIN_SAFE_INTEGER,
  ) {
  }

  public updateFromValue(value: number): void {
    this.minPressure = Math.min(this.minPressure, value);
    this.maxPressure = Math.max(this.maxPressure, value);
  }
}
